import { TurboModuleRegistry, Platform } from 'react-native';
import type { Spec } from '../../specs/NativeAppConfig';

export type AppStage = 'PROD' | 'GAMMA' | 'BETA' | 'PERSONAL' | 'LOCAL';
export type AppRegion = 'NA' | 'EU' | 'FE';

// Local dev only — injected by webpack DefinePlugin from dev.config.json
declare const __DEV_CONFIG__: { voiceSocketUrl?: string } | null;
const devConfigData = typeof __DEV_CONFIG__ !== 'undefined' ? __DEV_CONFIG__ : null;

interface AppConfig {
  stage: AppStage;
  region: AppRegion;
  hostOverride: string;
}


function buildUrl(stage: AppStage, region: AppRegion, hostOverride: string, prefix?: string): string {
  if (stage === 'LOCAL') return hostOverride;
  const rc = region.toLowerCase();
  const p = prefix ? `${prefix}.` : '';
  if (stage === 'PERSONAL') {
    return `https://${p}${hostOverride}.creator.kids.amazon.dev`;
  }
  // Assets host is global (no region); service host includes region
  if (prefix) {
    return `https://${p}${stage.toLowerCase()}.creator.kids.amazon.dev`;
  }
  return `https://${stage.toLowerCase()}.${rc}.creator.kids.amazon.dev`;
}

function getConfig(): AppConfig | null {
  if (Platform.OS !== 'web') {
    // Android: from TurboModule
    const native = TurboModuleRegistry.get<Spec>('AppConfig');
    if (native) {
      const constants = native.getConstants();
      if (constants?.stage) return constants as unknown as AppConfig;
    }
    return null;
  }
  // Web: set by the loader on window before the bundle loads
  const w = typeof window !== 'undefined' ? (window as any).__APP_CONFIG__ : null;
  if (w?.stage) return w as AppConfig;
  return null;
}

export function getVoiceSocketUrl(): string {
  const config = getConfig();
  if (config) {
    const url = buildUrl(config.stage, config.region, config.hostOverride);
    console.log(`[AppConfig] stage=${config.stage} region=${config.region} override=${config.hostOverride} socketUrl=${url}`);
    return url;
  }
  // Fallback for local dev (webpack dev server / Metro)
  if (devConfigData?.voiceSocketUrl) {
    return devConfigData.voiceSocketUrl;
  }
  return "http://localhost:8180";
}

export function getAssetsBaseUrl(): string {
  const config = getConfig();
  if (config) {
    return buildUrl(config.stage, config.region, config.hostOverride, 'assets');
  }
  return '';
}
